// JS file for ArticleItem
import '@main';

await u.domready();

const favBtns = document.querySelectorAll('.j-favorite-btn');

if (favBtns.length) {
  favBtns.forEach((favBtn) => {
    favBtn.addEventListener('click', () => {
      favBtn.classList.toggle('active');
    });
  });
}

u.trigger('load.share.this');
